export default __webpack_public_path__ + "static/media/ban-Acubis-2bk.8be5f1df.jpg";